import { useMatch } from "react-router";

/**
 * @returns true if the user is currently on a Draft page (Data Management or Data Preparation),
 *          false otherwise.
 */
export function useIsOnDraftPage(): boolean {
  const isOnDataManagementPage = !!useMatch("/data-management/*");
  const isOnDataPreparationPage = !!useMatch("/project/:projectId/draft/*");
  return isOnDataManagementPage || isOnDataPreparationPage;
}
